"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

/**
 * This file contains some helper functions which are stateless (provide a pure interface)
 * and are used by the timeline component.
 */

/**
 * Differance between two dates
 *
 * @param  {Date} first Date of the first event
 * @param  {Date} second Date of the second event
 * @return {number} Differance between the two dates
 */
var daydiff = exports.daydiff = function daydiff(first, second) {
  return Math.round(second - first);
};

/**
 * Takes a list of lists and zips them together (size should be the same).
 *
 * e.g. zip([['row0col0', 'row0col1', 'row0col2'], ['row1col0', 'row1col1', 'row1col2']]);
 * = [["row0col0","row1col0"], ["row0col1","row1col1"], ["row0col2","row1col2"]]
 * @param {array} rows An array (of size 2) of arrays (of equal size).
 * @return {array} An array (of size of either array in param) of arrays (of size 2)
 */
var zip = exports.zip = function zip(rows) {
  return rows[0].map(function (_, c) {
    return rows.map(function (row) {
      return row[c];
    });
  });
};

/**
 * Determines the minimum and maximum distance between a list of dates
 * @param {array} dates The array containing all the dates
 * @return {{min: number, max: number}} The minimum and maximum distances
 */
var dateDistanceExtremes = exports.dateDistanceExtremes = function dateDistanceExtremes(dates) {
  // determine the minimum distance among events
  var datePairs = zip([dates.slice(0, -1), dates.slice(1)]);
  var dateDistances = datePairs.map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        x = _ref2[0],
        y = _ref2[1];

    return daydiff(x, y);
  });

  // return the minimum distance between two dates but considering that all dates
  // are the same then return the provided minimum seperation.
  return {
    min: Math.min.apply(null, dateDistances),
    max: Math.max.apply(null, dateDistances)
  };
};

/**
 * Given dates and some bounds returns an array of positioning information w.r.t. some origin for
 * that set of dates.
 *
 * @param {dates} the array containing dates the dates
 * @param {number} labelWidth The width the label is going to use
 * @param {number} minEventPadding The minimum padding between events.
 * @param {number} maxEventPadding The maximum padding between events.
 * @param {number} startPadding The padding at the beginning of the timeline
 * @return {array} positioning information for dates from a given origin point
 */
// the interface for this function is pure
var cummulativeSeperation = exports.cummulativeSeperation = function cummulativeSeperation(dates, labelWidth, minEventPadding, maxEventPadding, startPadding) {
  // using dynamic programming to set up the distance from the origin of the timeline.
  var distances = new Array(dates.length);
  distances[0] = startPadding;

  // Calculating the minimum seperation between events
  var dateExtremes = dateDistanceExtremes(dates);
  var datesDiff = dateExtremes.max - dateExtremes.min;
  var paddingDiff = maxEventPadding - minEventPadding;
  // const halfLabel = labelWidth / 2;


  for (var index = 1; index < distances.length; index += 1) {
    var distance = daydiff(dates[index - 1], dates[index]);
    // relative spacing according to min and max seperation
    var seperation = datesDiff === 0 ? maxEventPadding : Math.round((distance - dateExtremes.min) * paddingDiff / datesDiff + minEventPadding);
    // the distance_from_origin(n) = distance_from_origin(n-1) + distance between n and n - 1.
    distances[index] = distances[index - 1] + labelWidth + seperation;
  }
  return distances;
};


//////////////////
// WEBPACK FOOTER
// ../react-template/lib/components/timeline/react-horizontal-timeline/helpers.js
// module id = 1152
// module chunks = 0